export default "__VITE_ASSET__a0eb3732__"